<template>
  <div>
    <videos-dialog ref="videosDialog" @submit="dialogSubmitted" />
    <video-edit-dialog
      ref="videoEditDialog"
      :key="value"
      @formSubmitted="fetchSelectedVideo"
    />
    <div class="box">
      <video
        v-if="selectedVideo"
        class="thumbnail"
        :src="src"
        controls
        preload="metadata"
      />
      <div class="video-info">
        <p class="video-info__title" v-if="selectedVideo">
          {{ selectedVideo.title }}
          <i
            class="video-info__edit-video-icon fa fa-edit"
            @click="openEditVideoDialog"
          />
        </p>
        <el-button @click="openDialog" type="info" class="open-dialog-button">
          <i class="fa fa-file-video-o"></i> Wybierz lub prześlij wideo
        </el-button>
      </div>
      <el-button
        @click.stop="removeVideo"
        class="remove-button"
        v-if="value"
        size="mini"
        icon="el-icon-delete"
        type="danger"
        title="Usuń wideo"
      >
      </el-button>
    </div>
  </div>
</template>
<script>
import VideosDialog from '@/components/inputs/VideoDialog/'
import VideoEditDialog from '@/components/inputs/VideoDialog/VideoEditDialog'
import { Video } from '@/api'

export default {
  props: ['value'],
  components: {
    VideosDialog,
    VideoEditDialog
  },
  data() {
    return {
      selectedVideo: null
    }
  },
  methods: {
    removeVideo() {
      this.$emit('input', null)
    },
    openDialog() {
      this.$refs.videosDialog.openDialog()
    },
    dialogSubmitted(video) {
      this.$emit('input', video)
    },
    fetchSelectedVideo() {
      Video.get({ id: this.value }).then(response => {
        this.selectedVideo = response.data
      })
    },
    openEditVideoDialog() {
      this.$refs.videoEditDialog.openDialog(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        value ? this.fetchSelectedVideo() : (this.selectedVideo = null)
      }
    }
  },
  computed: {
    src() {
      return this.selectedVideo ? this.selectedVideo.file_url : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.remove-button {
  position: absolute;
  right: 28px;
  top: 28px;
}

.open-dialog-button {
  vertical-align: middle;
}

.thumbnail {
  max-width: 140px;
  vertical-align: middle;
}

.video-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;

  &__title {
    font-weight: 700;
  }

  &__edit-video-icon {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
